import type React from 'react';

export interface BreakdownRowProps {
  value: string;
}

const BreakdownRow: React.FC<BreakdownRowProps> = ({ value }) => (
  <li key={value}>
    <div className="px-4 py-4 sm:px-6">
      <div className="flex items-center justify-between">
        <p className="truncate text-sm font-medium text-gray-600">{value}</p>
      </div>
    </div>
  </li>
);

export default BreakdownRow;
